import { logDecodingError } from "../../helpers/airbrake"
import { loadBackgroundImages }  from "../../helpers/image_loader"

export default (elmVenue: ElmVenue): void => {
  const node = document.getElementById("elm-spas-nearby")
  if (!node) return

  const spas = JSON.parse(node.dataset.elmFlags || "{}")
  const flags = {
    spas,
    queryString: window.location.search
  }
  const app = elmVenue.SpasNearby.init({ node, flags })

  app.ports.flagDecodingError.subscribe(() => logDecodingError(flags))
  loadBackgroundImages(document.querySelectorAll("#spas-nearby [data-img]"))
}
